var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCaretForward = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 5,
  height: 10,
  viewBox: "0 0 5 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.583956 9.28572C0.413441 9.28572 0.273625 9.23261 0.164175 9.1264C0.0547247 9.0435 0 8.90781 0 8.71902L0 1.281C0 1.15114 0.0547247 1.01546 0.164175 0.873618C0.273625 0.767402 0.413441 0.714294 0.583956 0.714294C0.717765 0.714294 0.839562 0.767402 0.949012 0.873618L4.7811 4.59279C4.92726 4.73431 5 4.86999 5 5.00017C5 5.1297 4.92726 5.26571 4.7811 5.40722L0.949012 9.1264C0.839562 9.23261 0.717765 9.28572 0.583956 9.28572Z",
  fill: "rgba(255, 255, 255, 0.4)"
})));
export default SvgIconCaretForward;